import { type FeaturesNameType } from '@/common/types/feature-name.type';

interface FeatureNameType {
  feature: Record<FeaturesNameType, string>;
}
export const FeatureNameConstant: FeatureNameType['feature'] = {
  weight: 'وزن',
  color: 'رنگ',
  size: 'سایز',
  dimension: 'ابعاد',
};
